/* Remove only GPI offer codes when their selected kit is no longer complete. */
(() => {
  const root = document.currentScript.dataset.root || '/';
  const sizes = { 'motorcycle-gloves': 2, 'cycling-gloves': 2, 'jacket-pants': 2, 'mesh-gloves': 2, 'hoodie-gloves': 2, 'rider-trio': 3, 'complete-kit': 5 };
  let pending;
  let pageCodes = JSON.parse(document.getElementById('gpi-cart-discounts')?.textContent || '[]');
  let relevant = !!sessionStorage.getItem('gpi:bundle-code');
  const isOfferCode = code => /^GPI\s*\|/.test(code || '');
  async function request(path, body) {
    const response = await fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Your cart could not be checked. Please refresh and try again.');
    return response.json();
  }
  function groups(cart) {
    const result = new Map();
    cart.items.forEach(item => {
      const p = item.properties || {};
      if (!p._gpi_offer_group || !sizes[p._gpi_offer_key] || item.quantity < 1) return;
      if (!result.has(p._gpi_offer_group)) result.set(p._gpi_offer_group, { key: p._gpi_offer_key, steps: new Set() });
      const group = result.get(p._gpi_offer_group);
      if (group.key === p._gpi_offer_key) group.steps.add(Number(p._gpi_offer_step));
    });
    return [...result.values()].map(group => ({ ...group, complete: Array.from({ length: sizes[group.key] }, (_, i) => i + 1).every(step => group.steps.has(step)) }));
  }
  async function remainingOfferCode() {
    for (let attempt = 0; attempt < 40 && typeof window.bndlr?.getCheckoutInfo !== 'function'; attempt++) await new Promise(resolve => setTimeout(resolve, 250));
    if (typeof window.bndlr?.getCheckoutInfo !== 'function') throw new Error('Offer pricing is still loading. Please try checkout again in a moment.');
    const info = await new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Offer pricing took too long. Please try checkout again.')), 20000);
      window.bndlr.getCheckoutInfo(value => { clearTimeout(timer); resolve(value); });
    });
    if (!info?.can_apply_discount || !info.code) throw new Error('Your remaining offer could not be confirmed. Please review your cart.');
    return info.code;
  }
  function renderSections(cart, sections) {
    sections.forEach(section => {
      if (!cart.sections?.[section.section]) return;
      const element = document.getElementById(section.id);
      const source = new DOMParser().parseFromString(cart.sections[section.section], 'text/html').querySelector(section.selector);
      if (element && source) (element.querySelector(section.selector) || element).innerHTML = source.innerHTML;
    });
  }
  async function reconcile() {
    if (window.gpiOfferCartBusy) return;
    const cart = await request('cart.js');
    if (window.gpiOfferCartBusy) return;
    // Checkout-applied codes can be present in Liquid while absent from Ajax cart.js.
    const previousCode = sessionStorage.getItem('gpi:bundle-code');
    const codes = [...new Set([...(cart.discount_codes || []).map(discount => discount.code), ...pageCodes, ...(isOfferCode(previousCode) ? [previousCode] : [])].filter(Boolean))];
    const selections = groups(cart);
    relevant = selections.length > 0 || codes.some(isOfferCode);
    if (!codes.some(isOfferCode)) return;
    if (selections.length && selections.every(group => group.complete)) return;
    const retainedCodes = codes.filter(code => !isOfferCode(code));
    if (selections.some(group => group.complete)) retainedCodes.push(await remainingOfferCode());
    const cartElement = document.querySelector('cart-items, cart-drawer-items');
    const sections = cartElement?.getSectionsToRender?.() || [];
    const updated = await request('cart/update.js', { discount: [...new Set(retainedCodes)].join(','), ...(sections.length ? { sections: sections.map(section => section.section), sections_url: root + 'cart' } : {}) });
    renderSections(updated, sections);
    pageCodes = retainedCodes;
    const currentCode = retainedCodes.find(isOfferCode);
    if (currentCode) sessionStorage.setItem('gpi:bundle-code', currentCode);
    else sessionStorage.removeItem('gpi:bundle-code');
    relevant = selections.length > 0 || !!currentCode;
    document.getElementById('gpi-cart-price-message')?.remove();
  }
  function check() {
    if (!pending) pending = reconcile().finally(() => { pending = null; });
    return pending;
  }
  function showError(error) {
    let message = document.getElementById('gpi-cart-price-message');
    if (!message) {
      message = document.createElement('p'); message.id = 'gpi-cart-price-message'; message.setAttribute('role', 'alert');
      (document.querySelector('#main-cart-footer .js-contents') || document.querySelector('main')).append(message);
    }
    message.textContent = error.message;
  }
  async function checkout(event) {
    if (!relevant || window.gpiOfferCartBusy) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try { await check(); window.location.assign(root + 'checkout'); }
    catch (error) { showError(error); }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]')) checkout(event);
  }, true);
  document.addEventListener('submit', event => { if (event.submitter?.name === 'checkout') checkout(event); }, true);
  const backgroundCheck = () => check().catch(error => { if (relevant) showError(error); });
  if (typeof subscribe === 'function') subscribe('cart-update', backgroundCheck);
  document.addEventListener('gpi:cart-updated', backgroundCheck);
  window.addEventListener('pageshow', backgroundCheck);
  backgroundCheck();
})();
